export default __webpack_public_path__ + "static/media/vue.7645bafd.svg";